
import CONFIG from '../../config';
import { Injectable, Component, OnInit, OnDestroy } from '@angular/core';
import { Location, DecimalPipe, CurrencyPipe } from '@angular/common';
// import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

// import { MultiColumnGridService } from '../shared/multi-column-grid.service';
import { AuthService } from '../shared/auth.service';
import { AccountService } from '../shared/account.service';
import { BackendService } from '../shared/backend.service';
// import { FilterService } from '../shared/filter.service';
// import { NotificationService } from '../notification/notification.service';
// import { OrderByService } from '../shared/orderby.service';
// import { PaginationService } from '../shared/pagination.service';
// import { SearchService } from '../shared/search.service';
// import { Utilities } from '../shared/utilities.service';

import { Subscription } from 'rxjs/Subscription';
import { AppService } from 'app/app.service';

// import { PositionsComponent } from '../menu/positions/positions.component';
@Component({
    selector: 'app-dash-home',
    templateUrl: './dash-home.component.html',
    providers: [
        DecimalPipe,
        // PositionsComponent
    ],
    styles: [`
        .fl-rt: {
            float: right;
        }
        a {
            font-weight:700;
            cursor: pointer;
        }
        .cancel {
            cursor: pointer;
            font-size: 1.2rem;
            opacity: 0.75;
            transition: opacity 0.3s ease;
        }
        .cancel:hover {
            opacity: 1;
        }
        .blueimg{
         //   background-image: url("http://www.centralbank.org.bb/portals/0/Images/mccu-logo.png");
            color:#24608C;  
            height: 300px; 
            padding-left: 220px;
            text-align: left;
          }

        'textcolour
        {
            text-color:rgb(255, 255, 255);
        }

        .imgalign
        {
            float:right;
            padding:15px;  
            bottom:550px;            
            width:825px; 
            height:315px
        }
    `]
})
@Injectable()
export class DashHomeComponent implements OnInit, OnDestroy {
    currentSettlementAccountSubscription: Subscription;
    FilterByStatus: FormGroup;
    totalEntries: number = 0;
    accounts: any;
    // accountnumber: string;
    scc: any;
     Customertype:any;
    constructor(
        public decimalPipe: DecimalPipe,
        // public comp: PositionsComponent,
        public formBuilder: FormBuilder,
        public backendService: BackendService,
        public authService: AuthService,
        public accountService: AccountService,
        public _appService:AppService
    ) { 
        // this.accountnumber = ""; 
    }

    ngOnInit() {
        this.currentSettlementAccountSubscription = this.accountService.currentSettlementAccountChange$.subscribe(currentSettlementAccount => this.currentSettlementAccountChange(currentSettlementAccount));
        //this.getAccountsDropdowns();
        this.FilterByStatus = this.formBuilder.group({ 'accountNumber': [] });
          this.Customertype= localStorage.getItem('CustomerType') || sessionStorage.getItem('CustomerType');
       // console.log(this.Customertype);
        this.FilterByStatus.controls['accountNumber'].setValue(this.accountService.currentSettlementAccount);
       
        this._appService.setUserLoggedIn(true);
    }
    ngOnDestroy() {
        if(this.currentSettlementAccountSubscription) { this.currentSettlementAccountSubscription.unsubscribe(); }
    }
    currentSettlementAccountChange(value){
        // this.activeSettlementAccount = value;
        //console.log(this.FilterByStatus.controls['accountNumber'].value);
        this.FilterByStatus.controls['accountNumber'].setValue(value);
    }
    // getAccountsDropdowns() {
    //     this.backendService.getData(`${CONFIG.getAccountsDropdowns}/${this.authService.CustomerID}`)
    //         .subscribe(data => {
    //             this.accounts = data['accounts'];
           
              
    //             this.totalEntries = this.accounts.length;
    //         });
    // }
    filterAuditLog() {
        this.scc = this.FilterByStatus.controls['accountNumber'].value;
        //console.log(this.FilterByStatus.controls['accountNumber'].value);
        let stringToSplit = this.scc;
        let x = stringToSplit.split("_");
        let value = x[0];
        this.accountService.setSAccount(value);
    }
    resetAuditListing() {

        this.FilterByStatus.controls['accountNumber'].setValue('Filter by Settlement Account');

    }
    getValue(item){
        if (item === 'Filter by Settlement Account'){
            return '';
        } else {
            let stringToSplit = item;
            let x = stringToSplit.split("_");
            
            return x[0];
        }
    }

}
